// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gkdo","name":"styles_name__IHHoL","phone":"styles_phone__teabR"};